import React, { PureComponent } from 'react';
import MontoMask from "../../../../Common/Components/Mask/MontoMask.jsx"

class Header extends PureComponent {
    constructor(props) {
        super(props)
    }

    render() {

        const { data } = this.props;
        let claseEstado;

        let estadoCuenta;

        switch (data.EstadoCuentaId) {

            case 3:
                claseEstado = "modal-news-modifications-button-lightgreen-central-rectangle position-label";
                estadoCuenta = "OPERATIVA";
                break;
            case 4:
                claseEstado = "modal-news-modifications-button-coral-central-rectangle position-label";
                estadoCuenta = "CON PROB";
                break;
            case 6:
                claseEstado = "modal-news-modifications-button-stronggray-central-rectangle position-label";
                estadoCuenta = "DADA BAJA";
                break;
            case 7:
                claseEstado = "modal-news-modifications-button-lightgray-central-rectangle position-label";
                estadoCuenta = "PROC. BAJA";
                break;
            default:
        }

        return (
            <div className="row box no-margin">
                <div className="col-xs-3">
                    <div>
                        <label className="label-primary">Pago Mínimo</label>
                    </div>
                    <div>
                        <MontoMask monto={data.PagoMinimo.toFixed(2)} moneda="" class="label-primary" />
                    </div>
                </div>
                <div className="col-xs-4">
                    <div>
                        <label className="label-primary">Vencimiento</label>
                    </div>
                    <div>
                        <label className="label-primary">{data.FechaVencimiento}</label>
                    </div>
                </div>
                <div className="col-xs-4">
                    <div>
                        <label className="label-primary">Estado de la Cuenta</label>
                    </div>
                    <div className={claseEstado}>
                        <label className="label-tipografy-estados">{estadoCuenta}</label>
                    </div>
                </div>
            </div>
        );
    }
}

export default Header;